import { useTranslation } from 'react-i18next';
import { CustomCardGrid } from '../../../../../components/CustomCardGrid';
import CustomTooltip from '../../../../../components/CustomTooltip';
import CustomChip from '../../../../../components/CustomChip';
import {
    CubeIcon,
    IconListButton,
    IconMaterialType,
    ModelIcon,
    NumericFieldChip,
    SerialIcon,
} from '../../../../../components/buttons/IconButtons';
import RowCardText from '../../../../../components/RowCardText';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../../enums/statusColorEnum';
import { status } from '../../../../../enums/statusEnum';
import { colors } from '../../../../../enums/colors';
import defaultImage from '../../../../../assets/IconsTables/ic-tools.svg';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { GetEquipmentDetailsById } from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { MATERIAL_TYPE } from '../Model/Model';
import { URL } from '../../../../../Apis/Constants';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const MaterialAndEquipmentCardGrid = () => {
    const [elementDetails, setElementDetails] = useState('');
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { id } = useParams();

    useEffect(() => {
        if (!id) return;

        dispatch(GetEquipmentDetailsById(id)).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                setElementDetails(data);
            },
        );
    }, [id, dispatch]);

    return (
        <>
            <CustomCardGrid
                isCheckboxShow={false}
                itemId={elementDetails?.id}
                statusColor={statusColor[elementDetails?.statusId]}
                fontColor={statusFontColor[elementDetails?.statusId]}
                borderColor={statusBorderColor[elementDetails?.statusId]}
                chipVariant={'large'}
                statusName={t(status[elementDetails?.statusId]) || EMPTY_VALUES.DEFAULT}
                srcImage={elementDetails?.fileUploadDto ? URL + elementDetails.fileUploadDto.filePath : defaultImage}
                height='border-full-shades-200'
                headClass={'minh-144px'}
                classNamePanelGrid=''
                isSquareImg={true}
                isDefaultIcon={true}
            >
                <div className='d-flex flex-column align-items-center mb-4 mt-0'>
                    <div className={"w-100"}>
                        <CustomTooltip
                            text={elementDetails?.name}
                            classes={`ibl-h3 ibl-font-w-600 text-ellipsis-2-rows text-center`}
                            showIfTruncated={true}
                            tooltipClasses={'p-0'}
                        />
                    </div>
                    <div className='d-flex flex-wrap gap-3 justify-content-center mt-3 w-100'>
                        {elementDetails?.categoryName && (
                            <CustomChip
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={elementDetails?.categoryName}
                                variant={'compact'}
                            />
                        )}
                        {elementDetails?.subCategoryName && (
                            <CustomChip
                                background={colors.primary100}
                                fontColor={colors.primary700}
                                borderColor={colors.primary300}
                                legend={elementDetails?.subCategoryName}
                                variant={'compact'}
                            />
                        )}
                    </div>
                </div>
                <div className='border-bottom-shades-300 mb-3 ' />
                <div className='d-flex align-items-center my-2'>
                    <NumericFieldChip className='w-20px h-20px' />
                    <RowCardText
                        className='my-2 ml-3 d-flex justify-content-between'
                        classNameValue='fs-14px ibl-font-w-300 '
                        classNameTitle='fs-12px ibl-font-w-600 '
                        title={t('code')}
                        tooltip={elementDetails?.code}
                        value={elementDetails?.code}

                    />
                </div>
                <div className='d-flex align-items-center my-2'>
                    <CubeIcon className='w-20px h-20px' />
                    <RowCardText
                        className='my-2 ml-3 d-flex justify-content-between'
                        classNameValue='fs-14px ibl-font-w-300 '
                        classNameTitle='fs-12px ibl-font-w-600 '
                        title={t('brand')}
                        tooltip={elementDetails?.brand}
                        value={elementDetails?.brand}
                    />
                </div>

                <div className='d-flex align-items-center my-2'>
                    <ModelIcon className='w-20px h-20px' />
                    <RowCardText
                        className='my-2 ml-3 d-flex justify-content-between'
                        classNameValue='fs-14px ibl-font-w-300 '
                        classNameTitle='fs-12px ibl-font-w-600 '
                        title={t('model')}
                        tooltip={elementDetails?.model}
                        value={elementDetails?.model}
                    />
                </div>
                <div className='d-flex align-items-center my-2'>
                    <SerialIcon className='w-20px h-20px' />
                    <RowCardText
                        className='my-2 ml-3 d-flex justify-content-between'
                        classNameValue='fs-14px ibl-font-w-300 '
                        classNameTitle='fs-12px ibl-font-w-600 '
                        title={t('serial_number')}
                        tooltip={elementDetails?.serialNumber}
                        value={elementDetails?.serialNumber}
                    />
                </div>

                <div className='d-flex align-items-center my-2'>
                    <IconMaterialType className='w-20px h-20px' />
                    <RowCardText
                        className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                        classNameValue='fs-14px ibl-font-w-300 '
                        classNameTitle='fs-12px ibl-font-w-600 '
                        title={t('material_type')}
                        tooltip={t(MATERIAL_TYPE[elementDetails?.equipmentOwner]?.trans)}
                        value={t(MATERIAL_TYPE[elementDetails?.equipmentOwner]?.trans)}
                    />
                </div>
                <div className='d-flex align-items-center my-2'>
                    <IconListButton className='w-20px h-20px' />
                    <RowCardText
                        className='my-2 ml-3 d-flex justify-content-between'
                        classNameValue='fs-14px ibl-font-w-300 '
                        classNameTitle='fs-12px ibl-font-w-600 '
                        title={t('specification')}
                        tooltip={elementDetails?.specification || EMPTY_VALUES.DEFAULT}
                        value={elementDetails?.specification || EMPTY_VALUES.DEFAULT}
                    />
                </div>
            </CustomCardGrid>
        </>
    );
};

export default MaterialAndEquipmentCardGrid;
